@if (packageFilterItems && packageFilterItems.length > 0) {
    <div #packagesFilterDropdown class="filter-container">
        <div class="filter-icon theme-filters" (click)="toggleFilterDropDown()"></div>
        @if (showFilterDropDown) {
            <div class="filter-dropdown">
                @for (item of packageFilterItems; track item.key) {
                    <div class="filter-item" [class.selected]="item == selectedFilterItem" (click)="filterOptionClicked(item)">
                        {{ item['key'] }}
                    </div>
                }
            </div>
        }
    </div>
}
